import styled from 'styled-components';
import { createReadableClass } from '@elfsight/widget-utils';
import { ServiceCard } from './service-card/service-card';
import { useServices } from './services-provider';

export function ServiceSelector() {
  const { services } = useServices();

  return (
    <Container>
      {services.map((service) => (
        <ServiceCard key={service.id} service={service} canChange />
      ))}
    </Container>
  );
}

const Container = styled.div.attrs({
  className: createReadableClass({
    component: 'service-selector',
    element: 'container'
  })
})`
  display: flex;
  flex-direction: column;
`;
